// extracted by mini-css-extract-plugin
module.exports = {"checkboxWrapper":"header-settings_checkboxWrapper__2g8sQ"};